module.exports = __webpack_public_path__ + "01_face.3a23487a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer1/01_face.png
// module id = TGuP
// module chunks = 0